import axios from "axios";
import "../../common/axiosInterceptor/axios-interceptor";

export const MachineDetailsAPI = async () => {
    return axios({
        method: 'get',
        url: `${process.env.REACT_APP_API_BASE_URL}/admindashboard/api/getMachineDetail`,
        authRequired: true
    })
}